import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import CssBaseline from '@mui/material/CssBaseline';
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/print/lib/styles/index.css';
import axios from 'axios';
import 'devextreme/dist/css/dx.material.blue.light.css';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { msalConfig } from './auth/config/authConfig';
import { env } from './env';
import './styles/styles.scss';

const container = document.getElementById('root');
const root = createRoot(container);
const msalInstance = new PublicClientApplication(msalConfig);
axios.defaults.baseURL = env.REACT_APP_API_URL;

root.render(
  <MsalProvider instance={msalInstance}>
    <CssBaseline />
    <HelmetProvider>
      <Worker workerUrl={'/pdf.worker.min.js'}>
        <App />
      </Worker>
    </HelmetProvider>
  </MsalProvider>
);
